/* ==========================================================================
   Aurum — card "Add" buttons

   Intercepts the small add-to-cart form on product cards so adding from a
   collection grid never navigates away. Falls back to a normal form POST if
   anything goes wrong, so the button always works.

   "Buy now" is deliberately NOT intercepted — it posts natively with
   return_to=/checkout, which is the fastest possible path to checkout.
   ========================================================================== */

(() => {
  const cart = () => document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-jw-card-form]');
    if (!form) return;

    const drawer = cart();
    if (!drawer) return; // no drawer/notification — let it post normally

    event.preventDefault();

    const button = form.querySelector('[data-jw-card-add]');
    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = '…';
    }

    const formData = new FormData(form);
    formData.append('sections', drawer.getSectionsToRender().map((s) => s.id));
    formData.append('sections_url', window.location.pathname);
    drawer.setActiveElement(document.activeElement);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          if (button) button.textContent = response.description || 'Unavailable';
          return;
        }

        drawer.renderContents(response);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'jw-card-actions', cartData: response });

        if (button) button.textContent = original;
      })
      .catch(() => {
        // Network failure — hand it back to the browser.
        form.submit();
      })
      .finally(() => {
        if (button) button.disabled = false;
      });
  });
})();
